export default "__VITE_ASSET__IS6SuU0$__"